import { useState } from 'react';
import { KeyRound } from 'lucide-react';

import { ErrorBanner } from '../../components/ErrorBanner';
import { Button, Card, CardBody, CardHead, Field, Input, Pill } from '../../components/ui';
import { useSecrets, useUpdateSecrets } from '../../hooks/useSecrets';
import type { SecretsUpdateRequest } from '../../types/api';
import styles from './AdminUsersPage.module.css';

export function AdminSecretsPage() {
  const secrets = useSecrets();
  const save = useUpdateSecrets();
  const [draft, setDraft] = useState<Record<string, string>>({});

  const items = secrets.data ?? [];
  const filled = Object.entries(draft).filter(([, value]) => value.trim().length > 0);

  const submit = () => {
    if (filled.length === 0) return;
    save.mutate(Object.fromEntries(filled) as SecretsUpdateRequest, {
      onSuccess: () => setDraft({}),
    });
  };

  return (
    <div className={styles.page}>
      <Card>
        <CardHead
          title="Ключи сервисов"
          hint="хранятся зашифрованными и подхватываются без перезапуска"
        />
        <CardBody pad className={styles.body}>
          {secrets.error && <ErrorBanner error={secrets.error} />}
          {save.error && <ErrorBanner error={save.error} />}

          {items.map((item) => (
            <Field
              key={item.key}
              layout="stacked"
              label={item.label}
              hint={
                item.is_set
                  ? `сейчас ${item.masked}${item.from_env ? ', из переменной окружения' : ''}`
                  : 'не задан'
              }
            >
              {(id) => (
                <Input
                  id={id}
                  type="password"
                  autoComplete="off"
                  value={draft[item.key] ?? ''}
                  placeholder={item.is_set ? 'оставьте пустым, чтобы не менять' : 'вставьте ключ'}
                  onChange={(event) =>
                    setDraft((current) => ({ ...current, [item.key]: event.target.value }))
                  }
                />
              )}
            </Field>
          ))}

          <div className={styles.actions}>
            <Button variant="primary" disabled={filled.length === 0 || save.isPending} onClick={submit}>
              <KeyRound size={13} strokeWidth={1.6} />
              {save.isPending ? 'Сохраняем…' : 'Сохранить'}
            </Button>
            {save.isSuccess && filled.length === 0 && <Pill tone="ok">сохранено</Pill>}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
